var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('nav',{staticClass:"header__container"},[_c('span',{staticClass:"header__logo",class:{
        'header__logo--active': _vm.home
      }},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.logo))])],1),_vm._v(" "),_c('ul',{staticClass:"header__menu"},[_c('li',{staticClass:"header__item",class:{
          'header__item--active': !_vm.home
        }},[_c('router-link',{attrs:{"to":"/what-is-wilks"}},[_vm._v("What is Wilks?")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8157fc14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Vheader.vue
// module id = Z6ge
// module chunks = 0